



























import { Component, Vue, Prop } from 'vue-property-decorator';
import NavbarEventsMenu from '@/views/layout/navigation/navbar-events-menu.vue';
import NavbarBoostViewMenu from '@/views/layout/navigation/navbar-boost-view-menu.vue';
@Component({
  components: {
    NavbarBoostViewMenu,
    NavbarEventsMenu
  }
})
export default class NavbarBoostView extends Vue  {
  @Prop()
  changePlanClick;

  menu: boolean = false;

  @Prop({ default: '' })
  contentClass: string;

  @Prop()
  nudgeLeft: number;

  @Prop()
  nudgeRight: number;

  @Prop()
  nudgeTop: number;

  @Prop()
  nudgeBottom: number;

  @Prop()
  offsetX: boolean;

  @Prop()
  offsetY: boolean;

  @Prop()
  closeMenu: any;
}
